import {memo, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import forEach from 'lodash/forEach';

import {notificationActions} from '@redux/modules/notification';

import LocalizedNotification from '../Common/LocalizedNotification/LocalizedNotification';

const renderNotification = (notification, removeNotification) => {
  const props = {
    onClose: () => removeNotification(notification.key),
    ...notification,
  };

  switch (notification.type) {
    case 'info':
      return LocalizedNotification.info(props);
    case 'warning':
      return LocalizedNotification.warning(props);
    case 'error':
      return LocalizedNotification.error(props);
    case 'success':
      return LocalizedNotification.success(props);

    default:
      return LocalizedNotification.open(props);
  }
};

export const Notifications = memo(function Notifications({notifications, removeNotification}) {
  const prevNotificationsRef = useRef();

  useEffect(() => {
    if (notifications !== prevNotificationsRef.current) {
      forEach(notifications, (notification) => renderNotification(notification, removeNotification));
    }
    prevNotificationsRef.current = notifications;
  });

  return null;
});

Notifications.propTypes = {
  notifications: PropTypes.array,
  removeNotification: PropTypes.func.isRequired,
};

const mapStateToProps = ({notification, localization}) => ({
  notifications: notification.notifications,
  locale: localization.locale,
});

const mapDispatchToProps = (dispatch) => ({
  removeNotification: (key) => dispatch(notificationActions.removeNotification(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
